import { statusLabel } from "../lib/format";

/** The colored dot is the status. Same vocabulary everywhere in the app. */
export function Sticker({ status }: { status: string }) {
  return <span className={`sticker s-${status}`}>{statusLabel(status)}</span>;
}
